import { format } from "date-fns";
import queryString from "query-string";
import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { IHistory } from "src/interfaces";
import { setLoading, setSuccess } from "../../../actions/loadingActions";
import { monthsAndYears } from "../../../constants/generals";
import { IFilters, IMonthlyForms } from "../../../interfaces";
import { MonthlyFormModel } from "../../../model/MonthlyFormModel";
import { getMonthlyFormList } from "../../../services/monthlyFormService";
import { splitDateIE } from "../../../utils/generalUtils";
import { BasePage } from "../../reusableComponents/BasePage";
import { ListPage } from "../../reusableComponents/ListPage";
import { MonthPicker } from "../../reusableComponents/MonthPicker";
import { RegionFilter } from "../../reusableComponents/RegionFilter";
import { ListItem } from "./ListItem";

export interface IMonthlyReportsProps {
  instances: MonthlyFormModel[];
  monthlyForms: IMonthlyForms;
  filters: IFilters;
  history: IHistory;
  location: any;
}

export interface IMonthlyReportsState {
  filterBy: string;
  regionName: string;
  date: Date;
  month: string;
  propsMonth: string;
}

export class MonthlyReportsImpl extends React.Component<
  IMonthlyReportsProps,
  IMonthlyReportsState
> {
  constructor(props: IMonthlyReportsProps) {
    super(props);
    let date = new Date();
    let region = "All";

    if (this.props.location.search) {
      date = queryString.parse(this.props.location.search).date;
      region = queryString.parse(this.props.location.search).region;
    }
    this.state = {
      filterBy: region,
      date,
      regionName: region,
      month: format(date, "MM-DD-YYYY"),
      propsMonth: format(date, "MM-DD-YYYY"),
    };
  }

  promise = async () => {
    let date = format(new Date(), "MM-DD-YYYY");
    let region = "All";
    if (this.props.location.search) {
      date = queryString.parse(this.props.location.search).date;
      region = queryString.parse(this.props.location.search).region;
    }
    const { mm, yyyy } = splitDateIE(date);
    await getMonthlyFormList(mm, yyyy, "All", region);
  };

  handleMonthFilter = async (e) => {
    this.setState({
      month: e,
    });
    const { yyyy } = splitDateIE(e);
    let mm = "";
    let selectedMonth = "";
    monthsAndYears.map((data) => {
      if (data.label === e.substr(3, 3)) {
        selectedMonth = `${data.value}-01-${yyyy}`;
        mm = data.value;
      }
    });
    this.setState({ propsMonth: selectedMonth });
    setLoading("MonthlyFormList");
    const queryString = `?date=${selectedMonth}&&region=${this.state.regionName}`;
    await getMonthlyFormList(mm, yyyy, "", this.state.regionName);
    this.props.history.push(`/reports/monthly${queryString}`);
    setSuccess("MonthlyFormList");
  };

  handleRegionFilter = async (filterName, regionName) => {
    let selectedMonth = "";
    this.setState({ regionName });
    let trialMonth = this.state.month;
    let finalMonth = "";
    if (isNaN(Number(trialMonth[0]))) {
      finalMonth = this.state.month;
    } else {
      const { mm, dd, yyyy } = splitDateIE(trialMonth);
      monthsAndYears.map((data) => {
        if (data.value === mm) {
          finalMonth = `${data.label} ${yyyy}`;
        }
      });
    }
    monthsAndYears.map((data) => {
      if (data.label === finalMonth.substring(0, 3)) {
        selectedMonth = `${data.value}-01-${finalMonth.substring(
          finalMonth.length - 4
        )}`;
      }
    });
    const { mm, dd, yyyy } = splitDateIE(selectedMonth);
    setLoading("MonthlyFormList");
    const queryString = `?date=${selectedMonth}&&region=${regionName}`;
    await getMonthlyFormList(mm, yyyy, "", regionName);
    this.props.history.push(`/reports/monthly${queryString}`);
    setSuccess("MonthlyFormList");
  };

  render() {
    const { instances } = this.props;
    return (
      <BasePage className="list-page-base" pageTitle="Monthly Reports">
        <ListPage
          identifier="MonthlyFormList"
          instances={instances}
          listItemComponent={ListItem}
          searchBy={["PlantId", "type", "Date", "Region"]}
          instanceOf={"plantInfo"}
          promise={this.promise}
          pageHeadings={[
            "#",
            "PlantID",
            "Region",
            "Type",
            "Submitted Date",
            "Updated Date",
          ]}
          cols={[1, 1, 3, 3, 2, 2]}
          searchPlaceHolder="Enter date, plant or form type to search..."
          emptyListMessage="No Monthly Reports found"
          chartFilter={
            <div className="filter-container">
              <MonthPicker
                defaultValue={this.state.propsMonth}
                years={[2013, 2015, 2016]}
                onClick={this.handleMonthFilter}
                popover={true}
              />
              <RegionFilter
                selectedValue={this.state.regionName}
                onChange={this.handleRegionFilter}
              />
            </div>
          }
        />
      </BasePage>
    );
  }
}

export function mapStateToProps(state) {
  const instances = MonthlyFormModel.list(state);
  return {
    instances,
  };
}

export const MonthlyReports = withRouter(
  connect<{}, {}, IMonthlyReportsProps>(mapStateToProps)(
    MonthlyReportsImpl as any
  )
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Reports/Monthly/MonthlyReports.tsx